import { createSlice } from '@reduxjs/toolkit';
import {
  createPaymentForOrderThunk,
  updatePaymentStatusThunk
} from './paymentsThunks';
import { type IErrorData } from '@/utils/getErrorData';

interface PaymentsState {
  creatingPayment: boolean;
  updatingPaymentById: Record<number, boolean>;
  error: IErrorData | null;
}

const initialState: PaymentsState = {
  creatingPayment: false,
  updatingPaymentById: {},
  error: null
};

const paymentsSlice = createSlice({
  name: 'payments',
  initialState,
  reducers: {
    resetPaymentsState(state) {
      state.creatingPayment = false;
      state.updatingPaymentById = {};
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPaymentForOrderThunk.pending, (state) => {
        state.creatingPayment = true;
        state.error = null;
      })
      .addCase(createPaymentForOrderThunk.fulfilled, (state) => {
        state.creatingPayment = false;
      })
      .addCase(createPaymentForOrderThunk.rejected, (state, action) => {
        state.creatingPayment = false;
        state.error = action.payload ?? null;
      });

    builder
      .addCase(updatePaymentStatusThunk.pending, (state, action) => {
        const paymentId = action.meta.arg.paymentId;
        state.updatingPaymentById[paymentId] = true;
        state.error = null;
      })
      .addCase(updatePaymentStatusThunk.fulfilled, (state, action) => {
        const paymentId = action.meta.arg.paymentId;
        state.updatingPaymentById[paymentId] = false;
      })
      .addCase(updatePaymentStatusThunk.rejected, (state, action) => {
        const paymentId = action.meta.arg.paymentId;
        state.updatingPaymentById[paymentId] = false;
        state.error = action.payload ?? null;
      });
  }
});

export const { resetPaymentsState } = paymentsSlice.actions;
export default paymentsSlice.reducer;
